export default __webpack_public_path__ + "static/media/sort.89fc819b.svg";